import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
const createVerificationCodeSchema = z.object({
    userId: z.string(),
    code: z.string(),
});
export class CreateVerificationCodeDto extends createZodDto(createVerificationCodeSchema) {
}
